import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { memo } from 'react';

const LexicalPlaceholder = memo(({ id, placeholder }) => {
  const [editor] = useLexicalComposerContext();

  const handleMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    editor.focus();
  };

  const handlePlaceholderClick = () => {
    document.querySelector(`.li-${id}`)?.focus();
  };

  return (
    <div className={'lexical-placeholder'} onMouseDown={handleMouseDown} onClick={handlePlaceholderClick}>
      {placeholder || ''}
    </div>
  );
});

LexicalPlaceholder.displayName = 'LexicalPlaceholder';

export default LexicalPlaceholder;
